import React, { useState, useEffect, useCallback } from "react";
import {
  TopToolbar,
  RefreshButton,
  ReferenceField,
  TextField,
  SelectInput,
  DateField,
  ListButton,
  ShowButton,
  Edit,
  SimpleForm,
  SaveButton,
  Toolbar,
  useTranslate,
  useRecordContext,
  useGetOne,
  TextInput,
  required,
  useNotify,
  useRefresh,
  useRedirect,
} from "react-admin";
import Select from "react-select";
import { RUN_TIME_API_ENDPOINT, CommonHeaderOption, getLocalStorageKey } from "../common/common";
import { useLocation, useNavigate } from "react-router-dom";
import Spinner from "../spinner";

// const topToolbarStyle = {
//     zIndex: 2,
//     display: 'inline-block',
//     float: 'right',
// };

const EditActions = ({ basePath, data }) => (
  <TopToolbar>
    <RefreshButton />
    <ListButton basePath={basePath} />
    <ShowButton basePath={basePath} record={data} />
  </TopToolbar>
);

const EditTitle = ({ record }) => {
  const translate = useTranslate();

  return (
    <span>
      {translate("resources.users.fields.edit_user")}{" "}
      {record ? `${record.first_name}` : ""}
    </span>
  );
};

const nameRegex = /^[A-Za-z]+(?: [A-Za-z]+)*$/;
const localStorageLocale = getLocalStorageKey("locale");

const PostEditToolbar = (props) => {
  const isNameInvalid =
    localStorageLocale === "en-GB" &&
    (
      !props.firstName?.trim() ||
      !props.lastName?.trim() ||
      !nameRegex.test(props.firstName.trim()) ||
      !nameRegex.test(props.lastName.trim())
    );

  return (
    <Toolbar {...props}>
      <div className="so-save-button">
        <button
          type="button"
          onClick={props.submitfun}
          disabled={
            props.isSaving ||
            !props.phoneNumber ||
            !Object.keys(props.businessId || {}).length ||
            isNameInvalid ||
            (
              props.businessRole.value === "contract_person" &&
              !Object.keys(props.contractList || {}).length
            )
          }
        >
          {props.isSaving ? (
            <>
              <span className="custom-save-spinner" />
              Saving...
            </>
          ) : (
            "SAVE"
          )}
        </button>
      </div>
    </Toolbar>
  );
};

const ClickItUserEdit = ({ permissions, ...props }) => {
  const translate = useTranslate();
  const location = useLocation();
  const path = location?.pathname.split("/");
  const { data } = useGetOne("users", { id: path[2] });
  const [saleOffNameSapCode, setSaleOffNameSapCode] = useState([]);
  const [businessError, setBusinessError] = useState(false);
  const [originalList, setOriginalList] = useState([]);

  const [phoneNumber, setPhoneNumber] = useState(null);
  const [firstName, setFirstName] = useState(null);
  const [lastName, setLastName] = useState(null);

  const [phoneNumberError, setPhoneNumberError] = useState(false);
  const [phoneErrorMsg, setPhoneErrorMsg] = useState(null);

  const [firstNameError, setFirstNameError] = useState(false);
  const [firstNameErrorMsg, setFirstNameErrorMsg] = useState(null);

  const [lastNameError, setLastNameError] = useState(false);
  const [lastNameErrorMsg, setLastNameErrorMsg] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const [soldToError, setSoldToError] = useState(false);

  // const businessData = data?.businesses.map((item) => ({
  //   id: item.id,
  //   value: item.label,
  //   label: item.label,
  //   sap_code: item.sap_code,
  // }));
  const [businessId, setBusinessId] = useState([]);
  console.log("businessId", data, businessId);

  const [businessRole, setBusinessRole] = useState({});
  const [businessRoleError, setBusinessRoleError] = useState(false);
  const rolesOption = [
    { value: "contract_person", label: "Contract Person" },
    { value: "owner", label: "Owner" },
    { value: "view_only", label: "View Only"}
  ];
  const [contractListOption, setContractListOption] = useState([]);
  const [contractListOGOption, setContractListOGOption] = useState([]);
  const [contractList,setContractList] = useState([]);
  const [contractError,setContractError] = useState(false);
  const [status,setStatus] = useState(false);



  useEffect(() => {
    console.log('dataaaaaaaaaaaaaaaaaaaaa',data );
    setPhoneNumber(data?.phone.replaceAll('+', ''));
    const businessData = data?.businesses.map((item) => ({
      id: item.id,
      value: item.label,
      label: item.label,
      sap_code: item.sap_code,
    }));
    setBusinessId(businessData);
    const roleData = data?.role_name == "contract_person" ? 
        { value: "contract_person", label: "Contract Person" } :
            data?.role_name == "owner" ? { value: "owner", label: "Owner" } : data?.role_name == "view_only" ?
                { value: "view_only", label: "View Only" } : { value: "employee", label: "Sales Person" } ;
    setBusinessRole(roleData);
    setStatus(data?.status);
    setFirstName(data?.first_name?.trim() || "");
    setLastName(data?.last_name?.trim() || "");

    setContractList(
      data?.contracts.map((item) => ({
          id: item.id,
          value: item.label,
          label: item.label,
          sap_code: item.sap_code.trim(),
      }))
    );
    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    options.method = "GET";
    fetch(`${apiUrl}/so_business_list`, options)
      .then((res) => {
        return res.json();
      })
      .then((jsonD) => {
        console.log("jsonD ===>", jsonD);
        let obj = {};
        obj.sap_order_materials = jsonD.data;
        obj.loadingShow = false;

        setOriginalList(
          obj.sap_order_materials.map((item) => ({
            id: item.id,
            value: item.label,
            label: item.label,
            sap_code: item.sap_code,
          }))
        );

        setSaleOffNameSapCode(
          obj.sap_order_materials.map((item) => ({
            id: item.id,
            value: item.label,
            label: item.label,
            sap_code: item.sap_code.trim(),
          }))
        );
      });
  }, [data]);

  // Function to remove similar objects from the second array
  const removeSimilarObjects = (arr1, arr2) => {
    return arr2.filter(item2 => !arr1.some(item1 => item1.id === item2.id));
  };

  // Function to add unique objects from array1 to array2
  const addUniqueObjects = (arr1, arr2) => {
    arr1.forEach(item1 => {
      const existsInArray2 = arr2.some(item2 => item2.id === item1.id);
      if (!existsInArray2) {
        arr2.push(item1);
      }
    });
  };


  useEffect(() => {
    if(businessId && Object.keys(businessId).length >0 && (Object.keys(businessRole).length >0 && businessRole.value == 'contract_person')) {
      setContractListOption([])
      console.log('uspppppppppp',businessId);
      const ids = businessId.map(item => item.id);
      console.log(ids);
      const encodedIds = encodeURIComponent(JSON.stringify(ids));
      const options = CommonHeaderOption();
      const apiUrl = RUN_TIME_API_ENDPOINT;
      options.method = "GET";
      fetch(`${apiUrl}/get_contracts_list?business_ids=${encodedIds}`, options)
        .then((res) => {
          return res.json();
        })
        .then((jsonD) => {
          console.log("jsonD ===>", jsonD);
          if (jsonD.contracts.length > 0) {
            let obj = {}; 
            // obj.contracts = jsonD.data;
            obj.loadingShow = false;
    
            // setContractListOption(
            //   jsonD.contracts.map((item) => ({
            //     id: item.id,
            //     value: item.label,
            //     label: item.label,
            //     sap_code: item.sap_code.trim(),
            //   }))
            // );

            const contractListFromApi = jsonD.contracts.map((item) => ({
              id: item.id,
              value: item.label,
              label: item.label,
              sap_code: item.sap_code.trim(),
            }))

            setContractListOGOption(contractListFromApi);

            const filteredArray2 = removeSimilarObjects(contractList, contractListFromApi);
            setContractListOption(filteredArray2)



          }
        });
    }

  }, [businessId,businessRole]);

  const handleChangeContracts = (e) => {
    console.log("hiiii", e);
    setContractError(false);
    setContractList(e);
    // console.log("saleOffNameSapCode in handleChange", saleOffNameSapCode);
    const arr = [...contractListOGOption];

    const theRemovedObject = removeSimilarObjects(e,arr);

    const newPushedArray = addUniqueObjects(theRemovedObject,contractListOption);
    // console.log('newPushedArray',newPushedArray);


    // let result =
    //   arr &&
    //   arr.filter(
    //     (item) => [e] && [e].filter((i) => i.id === item.id).length === 0
    //   );
    // console.log("////", result);
    // if ([e] === null) {
    //   result = [...originalList];
    //   setBusiness([]);
    // }
    // setBusiness([e]);
    // setSaleOffNameSapCode(result);
  };

  const handleChange = (e) => {
    console.log("hiiii", e , contractList);
    if (e.length >0 && contractList.length >0) {
      const sapSet = new Set(e.map(item => item.sap_code));
      // Filter the second array based on whether the sap value exists in the first array
      const filteredSecondArray = contractList.filter(item => sapSet.has(item.sap_code));
      setContractList(filteredSecondArray)
      console.log('filteredSecondArray ',filteredSecondArray);
    }


    setBusinessError(false);
    setBusinessId(e);
  };

  // const handleChange = (e) => {
  //   setSoldToError(false);
  //   // e.preventDefault();
  //   const arr = [...originalList];

  //   let result =
  //     arr &&
  //     arr.filter((item) => e && e.filter((i) => i.id === item.id).length === 0);
  //   if (e === null) {
  //     result = [...originalList];
  //     setBusinessId([]);
  //   }
  //   setBusinessId(e);
  //   setSaleOffNameSapCode(result);
  // };

  const cancelClick = () => {
    // setBusiness([]);
    setBusinessId({});
    setBusinessError(true);
    // setSaleOffNameSapCode(originalList);
  };

  const handleChangeRole = (e) => {
    console.log("hiiii", e);
    setBusinessRoleError(false);
    setBusinessRole(e);
    setContractList([]);
  };

  const transform = (data) => ({
    ...data,
    businesses: businessId,
  });

  const notify = useNotify();
  const refresh = useRefresh();
  const redirect = useRedirect();

  const onSuccess = (data) => {
    console.log("data =>", data);
    notify(`Changes saved`);
    // redirect('/posts');
    // refresh();
  };


  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (phoneNumber === "" || phoneNumber === null) {
      setPhoneNumberError(true);
      setPhoneErrorMsg("Enter Phone number");
    } else if (businessId.length === 0) {
      setSoldToError(true);
    } else if (phoneNumber.length < 7 || phoneNumber.length > 15) {
      setPhoneNumberError(true);
      setPhoneErrorMsg("Phone number should be min 7 and max 15 digit");
    } else if (localStorageLocale == "en-GB" && (!firstName || !firstName.trim())) {
    setFirstNameError(true);
    setFirstNameErrorMsg("Enter first name");
  } else if (localStorageLocale == "en-GB" && (firstName.trim().length < 2 || firstName.trim().length > 50)) {
    setFirstNameError(true);
    setFirstNameErrorMsg(
      "First name should be min 2 and max 50 characters"
    );
  } else if (localStorageLocale == "en-GB" && (firstName !== firstName.trim())) {
    setFirstNameError(true);
    setFirstNameErrorMsg(
      "First name should not start or end with a space"
    );
  } else if (localStorageLocale == "en-GB" && !nameRegex.test(firstName)) {
    setFirstNameError(true);
    setFirstNameErrorMsg(
      "First name should contain only letters and spaces"
    );
  } else if (localStorageLocale == "en-GB" && (!lastName || !lastName.trim())) {
    setLastNameError(true);
    setLastNameErrorMsg("Enter last name");
  } else if (localStorageLocale == "en-GB" && (lastName.trim().length < 2 || lastName.trim().length > 50)) {
    setLastNameError(true);
    setLastNameErrorMsg(
      "Last name should be min 2 and max 50 characters"
    );
  } else if (localStorageLocale == "en-GB" && lastName !== lastName.trim()) {
    setLastNameError(true);
    setLastNameErrorMsg(
      "Last name should not start or end with a space"
    );
  } else if (localStorageLocale == "en-GB" && !nameRegex.test(lastName)) {
    setLastNameError(true);
    setLastNameErrorMsg(
      "Last name should contain only letters and spaces"
    );
  }
    else if(businessRole.value == 'contract_person' && contractList.length <= 0){
      setContractError(true);
    } else {
      setPhoneNumberError(false);
      setFirstNameError(false);
      setLastNameError(false);
      setSoldToError(false);
      const options = CommonHeaderOption();
      const apiUrl = RUN_TIME_API_ENDPOINT;
      let req = {
        ...data,
        businesses: businessId,
        phone: phoneNumber,
        first_name: firstName,
        last_name: lastName,
        role_name: businessRole.value,
        contract_list: contractList,
        status:status,
      };
      console.log("req", req);
      options.method = "PATCH";
      options.body = JSON.stringify(req);

      setIsSaving(true)

      fetch(`${apiUrl}//users/${data.id}`, options)
      .then(async (res) => {
        // console.log("Status:", res.status);

        if (res.status === 204) {
          return {
            status: true,
            message: "Request completed successfully",
          };
        }

        const jsonD = await res.json();
        return jsonD;
      })
      .then((jsonD) => {
        // console.log("jsonD ===>", jsonD);

        if (jsonD.status === false) {
          // console.log(jsonD.message,"jsonD.message")
          notify(jsonD.message);
        } else {
          // console.log(jsonD.message,"jsonD.message 1")
          notify(jsonD.message);
          redirect("/users");
          refresh();
        }
      })
      .catch((error) => {
        console.error("Request failed:", error);
      }).finally(() => {
        setIsSaving(false);
      });
      }
  };

  

  const changePhoneNumber = (event) => {
    const pattern = new RegExp(/^[0-9\b]+$/);
    const reg = new RegExp("^d+$");
    // setSimilarNumberError(false);
    let positionObject = event.target.value;
    if (
      event.target.value === "" ||
      event.target.value === undefined ||
      event.target.value === null ||
      !event.target.value.trim().length ||
      reg.test(positionObject)
    ) {
      setPhoneNumberError(true);
      setPhoneErrorMsg("Enter Phone number");
    } else {
      setPhoneNumberError(false);
      setPhoneErrorMsg(null);
    }
    setPhoneNumber(positionObject);
  };



const validateName = (value, fieldName) => {
  if (!value) {
    return `Enter ${fieldName}`;
  }

  // Leading/trailing spaces
  if (value !== value.trim()) {
    return `${fieldName} should not start or end with a space`;
  }

  // Length validation
  if (value.length < 2 || value.length > 50) {
    return `${fieldName} should be min 2 and max 50 characters`;
  }

  // Only letters and single spaces between words
  if (!nameRegex.test(value)) {
    return `${fieldName} should contain only letters and spaces`;
  }

  return null;
};


const changeFirstName = (event) => {
  const value = event.target.value;

  const errorMsg = validateName(value, "First name");

  if (errorMsg) {
    setFirstNameError(true);
    setFirstNameErrorMsg(errorMsg);
  } else {
    setFirstNameError(false);
    setFirstNameErrorMsg(null);
  }

  setFirstName(value);
};

const changeLastName = (event) => {
  const value = event.target.value;

  const errorMsg = validateName(value, "Last name");

  if (errorMsg) {
    setLastNameError(true);
    setLastNameErrorMsg(errorMsg);
  } else {
    setLastNameError(false);
    setLastNameErrorMsg(null);
  }

  setLastName(value);
};



  // const changeFirstName = (event) => {
   
  //   let positionObject = event.target.value;
  //   if (
  //     event.target.value === "" ||
  //     event.target.value === undefined ||
  //     event.target.value === null ||
  //     !event.target.value.trim().length 
  //     // ||
  //     // reg.test(positionObject)
  //   ) {
  //     setFirstNameError(true);
  //     setFirstNameErrorMsg("Enter First Name");
  //   } else {
  //     setFirstNameError(false);
  //     setFirstNameErrorMsg(null);
  //   }
  //   setFirstName(positionObject);
  // };

  //  const changeLastName = (event) => {
   
  //   let positionObject = event.target.value;
  //   if (
  //     event.target.value === "" ||
  //     event.target.value === undefined ||
  //     event.target.value === null ||
  //     !event.target.value.trim().length 
  //     // ||
  //     // reg.test(positionObject)
  //   ) {
  //     setLastNameError(true);
  //     setLastNameErrorMsg("Enter Last Name");
  //   } else {
  //     setLastNameError(false);
  //     setLastNameErrorMsg(null);
  //   }
  //   setLastName(positionObject);
  // };

  const selectStatusChange = (event) => {
    setStatus(event.target.value);
  }

  return (
    <Edit
      actions={<EditActions />}
      title={<EditTitle />}
      {...props}
      // transform={transform}
      // mutationMode='pessimistic'
      // mutationOptions={{ onSuccess }}
    >
      <SimpleForm
        toolbar={<PostEditToolbar submitfun={(e) => handleFormSubmit(e)} businessRole={businessRole} phoneNumber={phoneNumber} firstName={firstName} lastName={lastName} businessId={businessId} contractList={contractList} isSaving={isSaving} />}
      >
        <label className="select-label">
          {translate('resources.users.fields.role')}<sup>*</sup>
          </label>
          <div className="select-retailer">
            <Select
              value={businessRole}
              onChange={handleChangeRole}
              isDisabled={data?.role_name == 'employee' || data?.role_name == 'Employee'}
              options={rolesOption}
              isMulti={false}
              required={true}
              IndicatorsContainer={true}
            />
            {/* <button onClick={cancelClick}>{translate('resources.users.fields.clear')}</button> */}
          </div>
          {businessRoleError && <p className="so-input-error">Enter Business Role</p>}
        <div className="ecu-select">
          <label className="select-label">
            {translate("resources.users.fields.sold_to")}
            <sup>*</sup>
          </label>
          <div className="select-retailer">
            <Select
              value={businessId}
              onChange={handleChange}
              options={saleOffNameSapCode}
              isMulti={true}
              source="businesses"
              required={true}
              IndicatorsContainer={true}
            />
            {soldToError && (
              <p className="complaint-file-error">Field cant be empty</p>
            )}
            {/* <button onClick={cancelClick}>
              {translate("resources.users.fields.clear")}
            </button> */}
          </div>
          {businessError && <p className="complaint-file-error">Enter Business Id</p>}
        </div>

        {
          (businessId && Object.keys(businessId).length >0 &&(Object.keys(businessRole).length > 0 && businessRole.value == 'contract_person')) &&
          <><label className="select-label">
          {translate('resources.users.fields.contracts')}<sup>*</sup>
          </label>
          <div className="select-retailer">
            <Select
              value={contractList}
              onChange={handleChangeContracts}
              options={contractListOption}
              isMulti={true}
              required={true}
              IndicatorsContainer={true}
            />
            {/* <button onClick={cancelClick}>{translate('resources.users.fields.clear')}</button> */}
            {contractError && <p className="complaint-file-error">Enter Contracts</p>}
          </div>
          </>
        }
        <div className="ecu-item-row">
          <div className="ecu-item">
             {localStorageLocale == "en-GB"? 

            <div className="so-input ecu-phone">
            <label>
              {translate("resources.users.fields.first_name")}
              <sup>*</sup>
            </label>
            <input
              type="text"
              min="2"
              maxLength="50"
              value={firstName}
              onChange={changeFirstName}
            />
            {firstNameError && (
              <p className="so-input-error">{firstNameErrorMsg}</p>
            )} 

            
              </div>
              :
              <>
              <label className="select-label label-name-uk">
                {translate("resources.users.fields.first_name")} :&nbsp;
              </label>
              
              <TextField source="first_name" />
              </>
            }

         
             
          </div>
          <div className="ecu-item">
           {localStorageLocale == "en-GB"? 

            <div className="so-input ecu-phone">
            <label>
              {translate("resources.users.fields.last_name")}
              <sup>*</sup>
            </label>
             <input
              type="text"
              min="2"
              maxLength="50"
              value={lastName}
              onChange={changeLastName}
            />
           {lastNameError && (
              <p className="so-input-error">{lastNameErrorMsg}</p>
            )} 
              </div>
              :
              <>
              <label className="select-label label-name-uk">
                {translate("resources.users.fields.last_name")} :&nbsp;
              </label>
              
              <TextField source="last_name" />
              </>
            }
          </div>
        </div>
        <div className="ecu-item-row">
          <div className="ecu-item">
            <label className="select-label">
              {translate("resources.users.fields.created_at")} :
            </label>
            &nbsp;
            <DateField
              // label={"Created at"}
              source="created_at"
            />
          </div>
          <div className="ecu-item">
            <label className="select-label">
              {translate("resources.users.fields.updated_at")} :
            </label>
            &nbsp;
            <DateField label={"Updated at"} source="updated_at" />
          </div>
        </div>
        {/* <label className="select-label">
          {" "}
          {translate("resources.users.fields.phone")}{" "}
        </label> */}

        {/* <TextField source="phone" /> */}
        <div className="ecu-item-row">
          <div className="ecu-item">
            {/* <TextInput type="number" source="phone" validate={[required()]} /> */}
            <div className="so-input ecu-phone">
            <label>
              {translate("resources.users.fields.phone")}
              <sup>*</sup>
            </label>
            <input
              type="number"
              min="7"
              maxLength="18"
              value={phoneNumber}
              onChange={changePhoneNumber}
            />
            {phoneNumberError && (
              <p className="so-input-error">{phoneErrorMsg}</p>
            )}

            {/* {similarNumberError && (
            <p className="so-input-error">{similarNumberMsg}</p>
          )} */}
          </div>
          </div>
          {/* <div className="ecu-item">
            <SelectInput
              source="status"
              choices={[
                { id: true, name: "True" },
                { id: false, name: "False" },
              ]}
              defaultValue="status"
            />
          </div> */}
          <div className="ecu-item">
            <div className="so-input">
              <label>Status</label>
              <select className="inapp-notification-sendto" name="status" value={status} onChange={selectStatusChange}>
                <option value="true">True</option>
                <option value="false">False</option>
              </select>
            </div>
          </div>
        </div>
      </SimpleForm>
    </Edit>
  );
};

export default ClickItUserEdit;
